import { createFileRoute } from "@tanstack/react-router";
import { NotificationSettingsScreen } from "../../screens/notify/index.ts";

/** `/settings/notifications`: what reaches you, where and how often. */
export const Route = createFileRoute("/_app/settings/notifications")({
  // the morning brief and when nobody acts are tabs of their own
  validateSearch: (search: Record<string, unknown>): { tab?: "brief" | "escalation" } =>
    search.tab === "brief" || search.tab === "escalation" ? { tab: search.tab } : {},
  component: NotificationSettingsScreen,
});
